export const countdownTimerMixin = {
    data() {
        return {
            countdownTimer: {
                days: null,
                hours: null,
                minutes: null,
                seconds: null,
            },
        };
    },
    methods: {
        formatUnitValue(value) {
            if (!value) {
                return '00';
            }
            return 10 > value ? '0' + value : value;
        },
        setTimer(time) {
            // set timer to count down to specific date/time
            // time example: "Nov 22, 2021 11:00:00"
            let endTime = new Date(time).getTime();
            let currentTime = new Date().getTime();
            let timeLeft = endTime - currentTime;

            this.countdownTimer.days = Math.floor(
                timeLeft / (1000 * 60 * 60 * 24)
            );
            this.countdownTimer.hours = Math.floor(
                (timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
            );
            this.countdownTimer.minutes = Math.floor(
                (timeLeft % (1000 * 60 * 60)) / (1000 * 60)
            );
            this.countdownTimer.seconds = Math.floor(
                (timeLeft % (1000 * 60)) / 1000
            );
        },
    },
};
